import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";
import { PHONE_CHANNEL_FORMATS } from "./constants";

const schema = yup.object({
  id: yup.string().nullable(),
  name: yup.string().nullable(),
  uuid: yup.string().nullable(),
  number: yup.string().nullable(),
  format: yup.string().nullable().oneOf(PHONE_CHANNEL_FORMATS),
  type: yup.string().nullable(),
  is_enabled: yup.boolean().nullable(),
  calling_name: yup.string().nullable(),
  linked_agent: yup.string().nullable(),
  ivr_script_id: yup.string().nullable(),
});

addKeyToFieldsRecursively(schema);

export default schema;
